import Axios, { AxiosError } from 'axios';
import { Options, ResponseError } from './dataTypes';

export const buildResponseError = (err: AxiosError): ResponseError => {
  const responseError: ResponseError = {
    error: err.response,
    status: err.response ? err.response.status : 500,
    data: [],
  };
  return responseError;
};

export const sendGet = async (path: string, providedOptions: Options) => {
  const options = providedOptions;
  options.withCredentials = true;
  return Axios.get(path, options).catch((err: AxiosError) => buildResponseError(err));
};

export const sendPut = async function sendPut(path: string, data: any, providedOptions: Options) {
  const options = providedOptions;
  options.withCredentials = true;
  return Axios.put(path, data, options).catch((err: AxiosError) => buildResponseError(err));
};

export const sendPost = async (path: string, providedOptions: Options, data: any) => {
  const options = providedOptions;
  options.withCredentials = true;
  return Axios.post(path, data, options).catch((err: AxiosError) => buildResponseError(err));
};

export const isCallSuccessful = (status: number): boolean => status >= 200 && status < 300;
